import TrashcanIcon from '@lmc/ui-kit/src/general/Icon/customShapes/Trashcan'
import AbsencesIcon from './customShapes/Absences'
import AppLinkIcon from './customShapes/AppLink'
import AttentionIcon from './customShapes/Attention'
import AuditIcon from './customShapes/AuditIcon'
import BillingHelpIcon from './customShapes/BillingHelp'
import BulkDownloadIcon from './customShapes/BulkDownload'
import CalendarIcon from './customShapes/Calendar'
import CancelIcon from './customShapes/Cancel'
import CapabilityCheckIcon from './customShapes/CapabilityCheck'
import CapabilityCrossIcon from './customShapes/CapabilityCross'
import CarePlanPBSAdlIcon from './customShapes/CarePlanPBSAdl'
import CheckIcon from './customShapes/Check'
import CircleXIcon from './customShapes/CircleX'
import CleanLargeLogoIcon from './customShapes/CleanLargeLogo'
import ContractAndPreferencesIcon from './customShapes/ContractAndPreferences'
import CustomArrowRightIcon from './customShapes/CustomArrowRight'
import DeleteIcon from './customShapes/Delete'
import DemoIcon from './customShapes/Demo'
import DownloadIcon from './customShapes/Download'
import FaqIcon from './customShapes/Faq'
import FeedbackIcon from './customShapes/Feedback'
import { FlagColouredIcon, FlagTransparentIcon } from './customShapes/Flag'
import GettingStartedIcon from './customShapes/GettingStarted'
import GPConnectSettingsIcon from './customShapes/GPConnectSettings'
import GPQuestionIcon from './customShapes/GPQuestion'
import GPServiceProfileIcon from './customShapes/GPServiceProfile'
import GroupBMIIcon from './customShapes/GroupsBMI'
import GroupsIncidentsIcon from './customShapes/GroupsIncidents'
import GroupsToDosIcon from './customShapes/GroupsToDos'
import HamburgerIcon from './customShapes/Hamburger'
import HealthRecordsIcon from './customShapes/HealthRecords'
import HelpIcon from './customShapes/Help'
import HelpCentreIcon from './customShapes/HelpCentre'
import HelpSSIcon from './customShapes/HelpSS'
import HobbiesIcon from './customShapes/Hobbies'
import HomeIcon from './customShapes/Home'
import IncidentsIcon from './customShapes/Incidents'
import InfoIcon from './customShapes/Info'
import LargeLogoIcon from './customShapes/LargeLogo'
import ListIcon from './customShapes/List'
import LogoIcon from './customShapes/Logo'
import LogoutIcon from './customShapes/Logout'
import LogsIcon from './customShapes/Logs'
import LogoPurplecon from './customShapes/LogsPurple'
import MailIcon from './customShapes/Mail'
import MapIcon from './customShapes/Map'
import MedicalRecordsIcon from './customShapes/MedicalRecords'
import {
  CarePlansHexagonIcon,
  ConsentHexagonIcon,
  DocsHexagonIcon,
  EmarHexagonIcon,
  FamilyHexagonIcon,
  FamilyPortalHexagonIcon,
  GroupsHexagonIcon,
  HandoversHexagonIcon,
  ProHexagonIcon
} from './customShapes/ModuleCardHexagons'
import NewLogoIcon from './customShapes/NewLogo'
import NewLogoTextIcon from './customShapes/NewLogoText'
import NhsIcon from './customShapes/Nhs'
import OtherIcon from './customShapes/Other'
import OverdueIcon from './customShapes/Overdue'
import PencilIcon from './customShapes/Pencil'
import PeopleIcon from './customShapes/People'
import PhoneIcon from './customShapes/Phone'
import PhoneCheckIcon from './customShapes/PhoneCheck'
import PinkCheckIcon from './customShapes/PinkCheck'
import PrivacyOfficerIcon from './customShapes/PrivacyOfficer'
import ProfileIcon from './customShapes/Profile'
import QuestionIcon from './customShapes/Question'
import ReportsCoronavirusIcon from './customShapes/ReportsCoronavirus'
import ReportsCQIIcon from './customShapes/ReportsCQI'
import ReportsDeliveryIcon from './customShapes/ReportsDelivery'
import ReportsFluidsIcon from './customShapes/ReportsFluids'
import ReportsFoodIcon from './customShapes/ReportsFood'
import ReportsGoalsIcon from './customShapes/ReportsGoals'
import ReportsHandoverIcon from './customShapes/ReportsHandover'
import ReportsHistoryIcon from './customShapes/ReportsHistory'
import ReportsIncidentsIcon from './customShapes/ReportsIncidents'
import ReportsMatrixIcon from './customShapes/ReportsMatrix'
import ReportsPreferencesIcon from './customShapes/ReportsPreferences'
import RosteringIcon from './customShapes/Rostering'
import SettingsIcon from './customShapes/Settings'
import SettingsBillingIcon from './customShapes/SettingsBilling'
import SettingsConsentIcon from './customShapes/SettingsConsent'
import SettingsFamilyIcon from './customShapes/SettingsFamily'
import SettingsNeedsIcon from './customShapes/SettingsNeeds'
import SettingsPerksIcon from './customShapes/SettingsPerks'
import SettingsPreferencesIcon from './customShapes/SettingsPreferences'
import SettingsZonesIcon from './customShapes/SettingsZones'
import ShareIcon from './customShapes/Share'
import SideChartsIcon from './customShapes/SideCharts'
import SideConsentIcon from './customShapes/SideConsent'
import SideDocumentsIcon from './customShapes/SideDocuments'
import SideInfoIcon from './customShapes/SideInfo'
import SideLogsIcon from './customShapes/SideLogs'
import SideMedicationIcon from './customShapes/SideMedication'
import SideMonitoringIcon from './customShapes/SideMonitoring'
import SidePlanningIcon from './customShapes/SidePlanning'
import SideProfileIcon from './customShapes/SideProfile'
import SignatureIcon from './customShapes/Signature'
import SocialIcon from './customShapes/Social'
import SocialFacebookIcon from './customShapes/SocialFacebook'
import SocialLinkedIcon from './customShapes/SocialLinkedIn'
import SocialTwitterIcon from './customShapes/SocialTwitter'
import SocialYoutubeIcon from './customShapes/SocialYoutube'
import { ThreeDots } from './customShapes/ThreeDots'
import TrainingAndSkillsIcon from './customShapes/TrainingAndSkills'
import WebinarIcon from './customShapes/Webinar'
import WriteListIcon from './customShapes/WriteList'

export enum IconType {
  Resident = 'RESIDENT',
  Computer = 'COMPUTER',
  Check = 'CHECK',
  Delete = 'DELETE',
  Logo = 'LOGO',
  People = 'PEOPLE',
  List = 'LIST',
  MedicalRecords = 'MEDICALRECORDS',
  PhoneCheck = 'PHONECHECK',
  Hobbies = 'HOBBIES',
  WriteList = 'WRITELIST',
  Info = 'INFO',
  Eye = 'EYE',
  CustomArrowRight = 'CustomArrowRight',
  Other = 'OTHER',
  Incidents = 'INCIDENTS',
  Signature = 'SIGNATURE',
  Pencil = 'PENCIL',
  Cancel = 'CANCEL',
  CapabilityCheck = 'CapabilityCheck',
  CapabilityCross = 'CapabilityCross',
  Save = 'SAVE',
  NewLogo = 'NEWLOGO',
  NewLogoText = 'NEWLOGOTEXT',
  Settings = 'SETTINGS',
  Help = 'HELP',
  Share = 'SHAREICON',
  Logs = 'LOGS',
  Hamburger = 'HAMBURGER',
  HandoversHexagon = 'HandoversHexagon',
  EmarHexagon = 'EmarHexagon',
  CarePlansHexagon = 'CarePlansHexagon',
  ProHexagon = 'ProHexagon',
  FamilyHexagon = 'FamilyHexagon',
  DocsHexagon = 'DocsHexagon',
  GroupsHexagon = 'GroupsHexagon',
  ThreeDots = 'ThreeDots',
  Overdue = 'overdue',
  Trashcan = 'Trashcan',
  FlagTransparent = 'FlagTransparent',
  FlagColoured = 'FlagColoured',
  SocialIcon = 'Social',
  MapIcon = 'Map',
  Calendar = 'Calendar',
  Question = 'Question',
  LogoPurple = 'LogoPurple',
  Attention = 'Attention',
  Phone = 'Phone',
  Mail = 'Mail',
  Profile = 'Profile',
  SideProfile = 'SideProfile',
  SideInfo = 'SideInfo',
  SideLogs = 'SideLogs',
  SideCharts = 'SideCharts',
  SideDocuments = 'SideDocuments',
  HealthRecords = 'HealthRecords',
  SidePlanning = 'SidePlanning',
  SideMonitoring = 'SideMonitoring',
  SideMedication = 'SideMedication',
  SideConsent = 'SideConsent',
  ReportsFluids = 'ReportsFluids',
  ReportsFood = 'ReportsFood',
  ReportsIncidents = 'ReportsIncidents',
  ReportsHandover = 'ReportsHandover',
  ReportsHistory = 'ReportsHistory',
  ReportsCQI = 'ReportsCQI',
  ReportsDelivery = 'ReportsDelivery',
  ReportsCoronavirus = 'ReportsCoronavirus',
  ReportsMatrix = 'ReportsMatrix',
  ReportsGoals = 'ReportsGoals',
  ConsentHexagon = 'ConsentHexagon',
  FamilyPortalHexagon = 'FamilyPortalHexagon',
  SettingsBilling = 'SettingsBilling',
  SettingsPreferences = 'SettingsPreferences',
  ReportsPreferences = 'ReportsPreferences',
  Rostering = 'Rostering',
  SettingsFamily = 'SettingsFamily',
  SettingsZones = 'SettingsZones',
  SettingsPerks = 'SettingsPerks',
  SettingsConsent = 'SettingsConsent',
  SettingsNeeds = 'SettingsNeeds',
  Home = 'Home',
  AppLink = 'ApLink',
  PinkCheck = 'PinkCheck',
  LargeLogoIcon = 'LargeLogoIcon',
  CleanLargeLogoIcon = 'CleanLargeLogoIcon',
  HelpCentreText = 'HelpCentre',
  GettingStartedIcon = 'GettingStarted',
  WebinarIcon = 'Webinar',
  FeedbackIcon = 'Feedback',
  DemoIcon = 'Demo',
  FaqIcon = 'Faq',
  BillingHelpIcon = 'BillingHelp',
  FacebookIcon = 'Facebook',
  YoutubeIcon = 'Youtube',
  SocialTwitterIcon = 'SocialTwitter',
  SocialLinkedIcon = 'SocialLinked',
  HelpSSIcon = 'HelpSS',
  LogoutIcon = 'Logout',
  PrivacyOfficerIcon = 'PrivacyOfficer',
  DownloadIcon = 'Download',
  AuditIcon = 'Audit',
  GroupsBMIIcon = 'GroupsBMI',
  GroupsToDosIcon = 'GroupsToDos',
  GroupsIncidentsIcon = 'GroupsIncidents',
  BulkDownloadIcon = 'BulkDownload',
  GPConnectSettingsIcon = 'GPConnect',
  GPServiceProfileIcon = 'GPServiceProfileIcon',
  GPQuestionIcon = 'GPQuestionIcon',
  NhsIcon = 'NhsIcon',
  CarePlanPBSAdlIcon = 'CarePlanPBSAdlIcon',
  TrainingAndSkillsIcon = 'TrainingAndSkillsIcon',
  ContractAndPreferencesIcon = 'ContractAndPreferencesIcon',
  AbsencesIcon = 'AbsencesIcon',
  CircleXIcon = 'CircleXIcon'
}

export type IconData = {
  [M in IconType]: {
    viewBox?: string
    data: string | React.ReactNode
    style?: React.CSSProperties
  }
}

export const ICONS: IconData = {
  [IconType.Resident]: {
    data: 'M34.6471 0C32.7982 0 31.2941 1.49825 31.2941 3.33984C31.2941 5.99992 29.1215 8.16406 26.451 8.16406H26.257C26.848 7.32183 27.1961 6.29857 27.1961 5.19531C27.1961 2.33062 24.8563 0 21.9804 0C19.1045 0 16.7647 2.33062 16.7647 5.19531C16.7647 6.29857 17.1128 7.32183 17.7038 8.16406H13.5903C14.1813 7.32183 14.5294 6.29857 14.5294 5.19531C14.5294 2.33062 12.1897 0 9.31373 0C6.4378 0 4.09804 2.33062 4.09804 5.19531C4.09804 6.47996 4.56961 7.65633 5.34802 8.56418C2.24364 9.59827 0 12.5214 0 15.957V22.6367C0 24.0691 1.16988 25.2344 2.60784 25.2344H3.72549V36.8867C3.72549 37.5015 4.2259 38 4.84314 38H13.7843C14.4016 38 14.902 37.5015 14.902 36.8867V25.2074C15.0237 25.2249 15.148 25.2344 15.2745 25.2344H16.3922V36.8867C16.3922 37.5015 16.8926 38 17.5098 38H26.451C27.0682 38 27.5686 37.5015 27.5686 36.8867V14.7903C33.4144 14.2286 38 9.30755 38 3.33984C38 1.49825 36.4959 0 34.6471 0V0ZM21.9804 2.22656C23.6238 2.22656 24.9608 3.55834 24.9608 5.19531C24.9608 6.83228 23.6238 8.16406 21.9804 8.16406C20.337 8.16406 19 6.83228 19 5.19531C19 3.55834 20.337 2.22656 21.9804 2.22656ZM9.31373 2.22656C10.9571 2.22656 12.2941 3.55834 12.2941 5.19531C12.2941 6.83228 10.9571 8.16406 9.31373 8.16406C7.67034 8.16406 6.33333 6.83228 6.33333 5.19531C6.33333 3.55834 7.67034 2.22656 9.31373 2.22656ZM12.6667 35.7734H10.4314V26.3477C10.4314 25.7328 9.93097 25.2344 9.31373 25.2344C8.69649 25.2344 8.19608 25.7328 8.19608 26.3477V35.7734H5.96078V24.1211C5.96078 23.5063 5.46038 23.0078 4.84314 23.0078H2.60784C2.40242 23.0078 2.23529 22.8413 2.23529 22.6367V15.957C2.23529 12.8877 4.74218 10.3906 7.82353 10.3906H15.0209C13.5692 11.8062 12.6667 13.7784 12.6667 15.957V35.7734ZM26.451 12.6172C25.8337 12.6172 25.3333 13.1156 25.3333 13.7305V35.7734H23.098V26.3477C23.098 25.7328 22.5976 25.2344 21.9804 25.2344C21.3632 25.2344 20.8627 25.7328 20.8627 26.3477V35.7734H18.6275V24.1211C18.6275 23.5063 18.127 23.0078 17.5098 23.0078H15.2745C15.0691 23.0078 14.902 22.8413 14.902 22.6367V15.957C14.902 12.8877 17.4088 10.3906 20.4902 10.3906H26.451C30.354 10.3906 33.5294 7.22764 33.5294 3.33984C33.5294 2.72598 34.0308 2.22656 34.6471 2.22656C35.2633 2.22656 35.7647 2.72598 35.7647 3.33984C35.7647 8.45537 31.5866 12.6172 26.451 12.6172Z',
    viewBox: '0 0 38 38'
  },
  [IconType.Computer]: {
    data: 'M16.3636 0H1.63636C0.736364 0 0 0.72 0 1.6V11.2C0 12.08 0.736364 12.8 1.63636 12.8H7.36364V14.4H5.72727V16H12.2727V14.4H10.6364V12.8H16.3636C17.2636 12.8 18 12.08 18 11.2V1.6C18 0.72 17.2636 0 16.3636 0ZM16.3636 11.2H1.63636V1.6H16.3636V11.2Z',
    viewBox: '0 0 18 16'
  },
  [IconType.Check]: {
    data: 'M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z',
    viewBox: '0 0 20 20'
  },
  [IconType.Delete]: {
    data: DeleteIcon,
    viewBox: '0 0 16 16'
  },
  [IconType.Logo]: {
    data: LogoIcon,
    viewBox: '0 0 119 30'
  },
  [IconType.People]: {
    data: PeopleIcon,
    viewBox: '0 0 37 37'
  },
  [IconType.MedicalRecords]: {
    data: MedicalRecordsIcon,
    viewBox: '0 0 38 38'
  },
  [IconType.List]: {
    data: ListIcon,
    viewBox: '0 0 38 38'
  },
  [IconType.PhoneCheck]: {
    data: PhoneCheckIcon,
    viewBox: '0 0 16 20'
  },
  [IconType.Hobbies]: {
    data: HobbiesIcon,
    viewBox: '0 0 38 38'
  },
  [IconType.WriteList]: {
    data: WriteListIcon,
    viewBox: '0 0 38 38'
  },
  [IconType.Info]: {
    data: InfoIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.Eye]: {
    data: 'M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z',
    viewBox: '0 0 22 16'
  },
  [IconType.CustomArrowRight]: {
    data: CustomArrowRightIcon,
    viewBox: '0 0 14 21'
  },
  [IconType.Other]: {
    data: OtherIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.Incidents]: {
    data: IncidentsIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.Signature]: {
    data: SignatureIcon,
    viewBox: '0 0 24 24'
  },
  [IconType.Pencil]: {
    data: PencilIcon,
    viewBox: '0 0 17 17'
  },
  [IconType.Save]: {
    data: CheckIcon,
    viewBox: '0 0 17 17'
  },
  [IconType.Cancel]: {
    data: CancelIcon,
    viewBox: '0 0 15 15'
  },
  [IconType.CapabilityCheck]: {
    data: CapabilityCheckIcon,
    viewBox: '0 0 16 16'
  },
  [IconType.CapabilityCross]: {
    data: CapabilityCrossIcon,
    viewBox: '0 0 16 16'
  },
  [IconType.NewLogo]: {
    data: NewLogoIcon,
    viewBox: '0 0 25 23'
  },
  [IconType.NewLogoText]: {
    data: NewLogoTextIcon,
    viewBox: '0 0 91 16'
  },
  [IconType.Settings]: {
    data: SettingsIcon,
    viewBox: '0 0 22 23'
  },
  [IconType.Help]: {
    data: HelpIcon,
    viewBox: '0 0 24 25'
  },
  [IconType.Share]: {
    data: ShareIcon,
    viewBox: '0 0 24 25'
  },
  [IconType.Logs]: {
    data: LogsIcon,
    viewBox: '0 0 24 25'
  },
  [IconType.Hamburger]: {
    data: HamburgerIcon,
    viewBox: '0 0 24 25'
  },
  [IconType.HandoversHexagon]: {
    data: HandoversHexagonIcon,
    viewBox: '0 0 183 200'
  },
  [IconType.EmarHexagon]: {
    data: EmarHexagonIcon,
    viewBox: '0 0 183 200'
  },
  [IconType.CarePlansHexagon]: {
    data: CarePlansHexagonIcon,
    viewBox: '0 0 152 165'
  },
  [IconType.ProHexagon]: {
    data: ProHexagonIcon,
    viewBox: '0 0 183 200'
  },
  [IconType.FamilyHexagon]: {
    data: FamilyHexagonIcon,
    viewBox: '0 0 183 200'
  },
  [IconType.DocsHexagon]: {
    data: DocsHexagonIcon,
    viewBox: '0 0 183 200'
  },
  [IconType.GroupsHexagon]: {
    data: GroupsHexagonIcon,
    viewBox: '0 0 183 200'
  },
  [IconType.ThreeDots]: {
    data: <ThreeDots />
  },
  [IconType.Overdue]: {
    data: OverdueIcon,
    viewBox: '0 0 24 24'
  },
  [IconType.Trashcan]: {
    data: TrashcanIcon,
    viewBox: '0 0 17 16'
  },
  [IconType.FlagTransparent]: {
    data: FlagTransparentIcon,
    viewBox: '0 0 17 16'
  },
  [IconType.FlagColoured]: {
    data: FlagColouredIcon,
    viewBox: '0 0 17 16'
  },
  [IconType.SocialIcon]: {
    data: SocialIcon,
    viewBox: '0 0 40 40'
  },
  [IconType.MapIcon]: {
    data: MapIcon,
    viewBox: '0 0 40 40'
  },
  [IconType.Calendar]: {
    data: CalendarIcon,
    viewBox: '0 0 33 32'
  },
  [IconType.Question]: {
    data: QuestionIcon,
    viewBox: '0 0 17 16'
  },
  [IconType.LogoPurple]: {
    data: LogoPurplecon,
    viewBox: '0 0 21 20'
  },
  [IconType.Attention]: {
    data: AttentionIcon,
    viewBox: '0 0 16 16'
  },
  [IconType.Phone]: {
    data: PhoneIcon,
    viewBox: '0 0 16 16'
  },
  [IconType.Mail]: {
    data: MailIcon,
    viewBox: '0 0 16 16'
  },
  [IconType.SideInfo]: {
    data: SideInfoIcon,
    viewBox: '0 0 16 20'
  },
  [IconType.SideProfile]: {
    data: SideProfileIcon,
    viewBox: '0 0 26 26'
  },
  [IconType.Profile]: {
    data: ProfileIcon,
    viewBox: '0 0 24 24'
  },
  [IconType.SideLogs]: {
    data: SideLogsIcon,
    viewBox: '0 0 20 14'
  },
  [IconType.SideCharts]: {
    data: SideChartsIcon,
    viewBox: '0 0 18 18'
  },
  [IconType.SideDocuments]: {
    data: SideDocumentsIcon,
    viewBox: '0 0 16 20'
  },
  [IconType.HealthRecords]: {
    data: HealthRecordsIcon,
    viewBox: '0 0 26 26'
  },
  [IconType.SidePlanning]: {
    data: SidePlanningIcon,
    viewBox: '0 0 18 20'
  },
  [IconType.SideMonitoring]: {
    data: SideMonitoringIcon,
    viewBox: '0 0 18 18'
  },
  [IconType.SideMedication]: {
    data: SideMedicationIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.SideConsent]: {
    data: SideConsentIcon,
    viewBox: '0 0 20 19'
  },
  [IconType.ReportsFluids]: {
    data: ReportsFluidsIcon,
    viewBox: '0 0 15 20'
  },
  [IconType.ReportsFood]: {
    data: ReportsFoodIcon,
    viewBox: '0 0 17 20'
  },
  [IconType.ReportsIncidents]: {
    data: ReportsIncidentsIcon,
    viewBox: '0 0 19 20'
  },
  [IconType.ReportsHandover]: {
    data: ReportsHandoverIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.ReportsHistory]: {
    data: ReportsHistoryIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.ReportsCQI]: {
    data: ReportsCQIIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.ReportsDelivery]: {
    data: ReportsDeliveryIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.ReportsCoronavirus]: {
    data: ReportsCoronavirusIcon,
    viewBox: '0 0 21 20'
  },
  [IconType.ReportsMatrix]: {
    data: ReportsMatrixIcon,
    viewBox: '0 0 19 20'
  },
  [IconType.ReportsGoals]: {
    data: ReportsGoalsIcon,
    viewBox: '0 0 19 20'
  },
  [IconType.ConsentHexagon]: {
    data: ConsentHexagonIcon,
    viewBox: '0 0 152 166'
  },
  [IconType.FamilyPortalHexagon]: {
    data: FamilyPortalHexagonIcon,
    viewBox: '0 0 152 165'
  },
  [IconType.SettingsBilling]: {
    data: SettingsBillingIcon,
    viewBox: '0 0 20 15'
  },
  [IconType.SettingsPreferences]: {
    data: SettingsPreferencesIcon,
    viewBox: '0 0 17 18'
  },
  [IconType.ReportsPreferences]: {
    data: ReportsPreferencesIcon,
    viewBox: '0 0 17 18'
  },
  [IconType.Rostering]: {
    data: RosteringIcon,
    viewBox: '0 0 17 18'
  },
  [IconType.SettingsFamily]: {
    data: SettingsFamilyIcon,
    viewBox: '0 0 17 18'
  },
  [IconType.SettingsZones]: {
    data: SettingsZonesIcon,
    viewBox: '0 0 16 20'
  },
  [IconType.SettingsPerks]: {
    data: SettingsPerksIcon,
    viewBox: '0 0 19 18'
  },
  [IconType.SettingsConsent]: {
    data: SettingsConsentIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.SettingsNeeds]: {
    data: SettingsNeedsIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.Home]: {
    data: HomeIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.AppLink]: {
    data: AppLinkIcon,
    viewBox: '0 0 146 146'
  },
  [IconType.PinkCheck]: {
    data: PinkCheckIcon,
    viewBox: '0 0 57 41'
  },
  [IconType.LargeLogoIcon]: {
    data: LargeLogoIcon,
    viewBox: '0 0 219 39'
  },
  [IconType.CleanLargeLogoIcon]: {
    data: CleanLargeLogoIcon,
    viewBox: '0 0 585 837'
  },
  [IconType.HelpCentreText]: {
    data: HelpCentreIcon,
    viewBox: '40 0 200 41'
  },
  [IconType.GettingStartedIcon]: {
    data: GettingStartedIcon,
    viewBox: '0 0 33 47'
  },
  [IconType.WebinarIcon]: {
    data: WebinarIcon,
    viewBox: '0 0 47 39'
  },
  [IconType.FeedbackIcon]: {
    data: FeedbackIcon,
    viewBox: '0 0 47 43'
  },
  [IconType.DemoIcon]: {
    data: DemoIcon,
    viewBox: '0 0 47 47'
  },
  [IconType.FaqIcon]: {
    data: FaqIcon,
    viewBox: '0 0 49 49'
  },
  [IconType.BillingHelpIcon]: {
    data: BillingHelpIcon,
    viewBox: '0 0 49 33'
  },
  [IconType.FacebookIcon]: {
    data: SocialFacebookIcon,
    viewBox: '0 0 40 40'
  },
  [IconType.YoutubeIcon]: {
    data: SocialYoutubeIcon,
    viewBox: '0 0 40 40'
  },
  [IconType.SocialTwitterIcon]: {
    data: SocialTwitterIcon,
    viewBox: '0 0 40 34'
  },
  [IconType.SocialLinkedIcon]: {
    data: SocialLinkedIcon,
    viewBox: '0 0 40 40'
  },
  [IconType.HelpSSIcon]: {
    data: HelpSSIcon,
    viewBox: '0 0 24 25'
  },
  [IconType.LogoutIcon]: {
    data: LogoutIcon,
    viewBox: '0 0 16 16'
  },
  [IconType.PrivacyOfficerIcon]: {
    data: PrivacyOfficerIcon,
    viewBox: '0 0 14 16'
  },
  [IconType.DownloadIcon]: {
    data: DownloadIcon,
    viewBox: '0 0 18 18'
  },
  [IconType.AuditIcon]: {
    data: AuditIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.GroupsBMIIcon]: {
    data: GroupBMIIcon,
    viewBox: '0 0 22 18'
  },
  [IconType.GroupsToDosIcon]: {
    data: GroupsToDosIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.GroupsIncidentsIcon]: {
    data: GroupsIncidentsIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.BulkDownloadIcon]: {
    data: BulkDownloadIcon,
    viewBox: '0 0 16 16'
  },
  [IconType.GPConnectSettingsIcon]: {
    data: GPConnectSettingsIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.GPServiceProfileIcon]: {
    data: GPServiceProfileIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.GPQuestionIcon]: {
    data: GPQuestionIcon,
    viewBox: '0 0 16 16'
  },
  [IconType.NhsIcon]: {
    data: NhsIcon,
    viewBox: '0 0 20 10'
  },
  [IconType.CarePlanPBSAdlIcon]: {
    data: CarePlanPBSAdlIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.TrainingAndSkillsIcon]: {
    data: TrainingAndSkillsIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.ContractAndPreferencesIcon]: {
    data: ContractAndPreferencesIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.AbsencesIcon]: {
    data: AbsencesIcon,
    viewBox: '0 0 20 20'
  },
  [IconType.CircleXIcon]: {
    data: CircleXIcon,
    viewBox: '0 0 26 26'
  }
}

export default IconType

export type AntIcons =
  | 'AccountBookFilled'
  | 'AccountBookOutlined'
  | 'AccountBookTwoTone'
  | 'AimOutlined'
  | 'AlertFilled'
  | 'AlertOutlined'
  | 'AlertTwoTone'
  | 'AlibabaOutlined'
  | 'AlignCenterOutlined'
  | 'AlignLeftOutlined'
  | 'AlignRightOutlined'
  | 'AlipayCircleFilled'
  | 'AlipayCircleOutlined'
  | 'AlipayOutlined'
  | 'AlipaySquareFilled'
  | 'AliwangwangFilled'
  | 'AliwangwangOutlined'
  | 'AliyunOutlined'
  | 'AmazonCircleFilled'
  | 'AmazonOutlined'
  | 'AmazonSquareFilled'
  | 'AndroidFilled'
  | 'AndroidOutlined'
  | 'AntCloudOutlined'
  | 'AntDesignOutlined'
  | 'ApartmentOutlined'
  | 'ApiFilled'
  | 'ApiOutlined'
  | 'ApiTwoTone'
  | 'AppleFilled'
  | 'AppleOutlined'
  | 'AppstoreAddOutlined'
  | 'AppstoreFilled'
  | 'AppstoreOutlined'
  | 'AppstoreTwoTone'
  | 'AreaChartOutlined'
  | 'ArrowDownOutlined'
  | 'ArrowLeftOutlined'
  | 'ArrowRightOutlined'
  | 'ArrowUpOutlined'
  | 'ArrowsAltOutlined'
  | 'AudioFilled'
  | 'AudioMutedOutlined'
  | 'AudioOutlined'
  | 'AudioTwoTone'
  | 'AuditOutlined'
  | 'BackwardFilled'
  | 'BackwardOutlined'
  | 'BankFilled'
  | 'BankOutlined'
  | 'BankTwoTone'
  | 'BarChartOutlined'
  | 'BarcodeOutlined'
  | 'BarsOutlined'
  | 'BehanceCircleFilled'
  | 'BehanceOutlined'
  | 'BehanceSquareFilled'
  | 'BehanceSquareOutlined'
  | 'BellFilled'
  | 'BellOutlined'
  | 'BellTwoTone'
  | 'BgColorsOutlined'
  | 'BlockOutlined'
  | 'BoldOutlined'
  | 'BookFilled'
  | 'BookOutlined'
  | 'BookTwoTone'
  | 'BorderBottomOutlined'
  | 'BorderHorizontalOutlined'
  | 'BorderInnerOutlined'
  | 'BorderLeftOutlined'
  | 'BorderOuterOutlined'
  | 'BorderOutlined'
  | 'BorderRightOutlined'
  | 'BorderTopOutlined'
  | 'BorderVerticleOutlined'
  | 'BorderlessTableOutlined'
  | 'BoxPlotFilled'
  | 'BoxPlotOutlined'
  | 'BoxPlotTwoTone'
  | 'BranchesOutlined'
  | 'BugFilled'
  | 'BugOutlined'
  | 'BugTwoTone'
  | 'BuildFilled'
  | 'BuildOutlined'
  | 'BuildTwoTone'
  | 'BulbFilled'
  | 'BulbOutlined'
  | 'BulbTwoTone'
  | 'CalculatorFilled'
  | 'CalculatorOutlined'
  | 'CalculatorTwoTone'
  | 'CalendarFilled'
  | 'CalendarOutlined'
  | 'CalendarTwoTone'
  | 'CameraFilled'
  | 'CameraOutlined'
  | 'CameraTwoTone'
  | 'CarFilled'
  | 'CarOutlined'
  | 'CarTwoTone'
  | 'CaretDownFilled'
  | 'CaretDownOutlined'
  | 'CaretLeftFilled'
  | 'CaretLeftOutlined'
  | 'CaretRightFilled'
  | 'CaretRightOutlined'
  | 'CaretUpFilled'
  | 'CaretUpOutlined'
  | 'CarryOutFilled'
  | 'CarryOutOutlined'
  | 'CarryOutTwoTone'
  | 'CheckCircleFilled'
  | 'CheckCircleOutlined'
  | 'CheckCircleTwoTone'
  | 'CheckOutlined'
  | 'CheckSquareFilled'
  | 'CheckSquareOutlined'
  | 'CheckSquareTwoTone'
  | 'ChromeFilled'
  | 'ChromeOutlined'
  | 'CiCircleFilled'
  | 'CiCircleOutlined'
  | 'CiCircleTwoTone'
  | 'CiOutlined'
  | 'CiTwoTone'
  | 'ClearOutlined'
  | 'ClockCircleFilled'
  | 'ClockCircleOutlined'
  | 'ClockCircleTwoTone'
  | 'CloseCircleFilled'
  | 'CloseCircleOutlined'
  | 'CloseCircleTwoTone'
  | 'CloseOutlined'
  | 'CloseSquareFilled'
  | 'CloseSquareOutlined'
  | 'CloseSquareTwoTone'
  | 'CloudDownloadOutlined'
  | 'CloudFilled'
  | 'CloudOutlined'
  | 'CloudServerOutlined'
  | 'CloudSyncOutlined'
  | 'CloudTwoTone'
  | 'CloudUploadOutlined'
  | 'ClusterOutlined'
  | 'CodeFilled'
  | 'CodeOutlined'
  | 'CodeSandboxCircleFilled'
  | 'CodeSandboxOutlined'
  | 'CodeSandboxSquareFilled'
  | 'CodeTwoTone'
  | 'CodepenCircleFilled'
  | 'CodepenCircleOutlined'
  | 'CodepenOutlined'
  | 'CodepenSquareFilled'
  | 'CoffeeOutlined'
  | 'ColumnHeightOutlined'
  | 'ColumnWidthOutlined'
  | 'CommentOutlined'
  | 'CompassFilled'
  | 'CompassOutlined'
  | 'CompassTwoTone'
  | 'CompressOutlined'
  | 'ConsoleSqlOutlined'
  | 'ContactsFilled'
  | 'ContactsOutlined'
  | 'ContactsTwoTone'
  | 'ContainerFilled'
  | 'ContainerOutlined'
  | 'ContainerTwoTone'
  | 'ControlFilled'
  | 'ControlOutlined'
  | 'ControlTwoTone'
  | 'CopyFilled'
  | 'CopyOutlined'
  | 'CopyTwoTone'
  | 'CopyrightCircleFilled'
  | 'CopyrightCircleOutlined'
  | 'CopyrightCircleTwoTone'
  | 'CopyrightOutlined'
  | 'CopyrightTwoTone'
  | 'CreditCardFilled'
  | 'CreditCardOutlined'
  | 'CreditCardTwoTone'
  | 'CrownFilled'
  | 'CrownOutlined'
  | 'CrownTwoTone'
  | 'CustomerServiceFilled'
  | 'CustomerServiceOutlined'
  | 'CustomerServiceTwoTone'
  | 'DashOutlined'
  | 'DashboardFilled'
  | 'DashboardOutlined'
  | 'DashboardTwoTone'
  | 'DatabaseFilled'
  | 'DatabaseOutlined'
  | 'DatabaseTwoTone'
  | 'DeleteColumnOutlined'
  | 'DeleteFilled'
  | 'DeleteOutlined'
  | 'DeleteRowOutlined'
  | 'DeleteTwoTone'
  | 'DeliveredProcedureOutlined'
  | 'DeploymentUnitOutlined'
  | 'DesktopOutlined'
  | 'DiffFilled'
  | 'DiffOutlined'
  | 'DiffTwoTone'
  | 'DingdingOutlined'
  | 'DingtalkCircleFilled'
  | 'DingtalkOutlined'
  | 'DingtalkSquareFilled'
  | 'DisconnectOutlined'
  | 'DislikeFilled'
  | 'DislikeOutlined'
  | 'DislikeTwoTone'
  | 'DollarCircleFilled'
  | 'DollarCircleOutlined'
  | 'DollarCircleTwoTone'
  | 'DollarOutlined'
  | 'DollarTwoTone'
  | 'DotChartOutlined'
  | 'DoubleLeftOutlined'
  | 'DoubleRightOutlined'
  | 'DownCircleFilled'
  | 'DownCircleOutlined'
  | 'DownCircleTwoTone'
  | 'DownOutlined'
  | 'DownSquareFilled'
  | 'DownSquareOutlined'
  | 'DownSquareTwoTone'
  | 'DownloadOutlined'
  | 'DragOutlined'
  | 'DribbbleCircleFilled'
  | 'DribbbleOutlined'
  | 'DribbbleSquareFilled'
  | 'DribbbleSquareOutlined'
  | 'DropboxCircleFilled'
  | 'DropboxOutlined'
  | 'DropboxSquareFilled'
  | 'EditFilled'
  | 'EditOutlined'
  | 'EditTwoTone'
  | 'EllipsisOutlined'
  | 'EnterOutlined'
  | 'EnvironmentFilled'
  | 'EnvironmentOutlined'
  | 'EnvironmentTwoTone'
  | 'EuroCircleFilled'
  | 'EuroCircleOutlined'
  | 'EuroCircleTwoTone'
  | 'EuroOutlined'
  | 'EuroTwoTone'
  | 'ExceptionOutlined'
  | 'ExclamationCircleFilled'
  | 'ExclamationCircleOutlined'
  | 'ExclamationCircleTwoTone'
  | 'ExclamationOutlined'
  | 'ExpandAltOutlined'
  | 'ExpandOutlined'
  | 'ExperimentFilled'
  | 'ExperimentOutlined'
  | 'ExperimentTwoTone'
  | 'ExportOutlined'
  | 'EyeFilled'
  | 'EyeInvisibleFilled'
  | 'EyeInvisibleOutlined'
  | 'EyeInvisibleTwoTone'
  | 'EyeOutlined'
  | 'EyeTwoTone'
  | 'FacebookFilled'
  | 'FacebookOutlined'
  | 'FallOutlined'
  | 'FastBackwardFilled'
  | 'FastBackwardOutlined'
  | 'FastForwardFilled'
  | 'FastForwardOutlined'
  | 'FieldBinaryOutlined'
  | 'FieldNumberOutlined'
  | 'FieldStringOutlined'
  | 'FieldTimeOutlined'
  | 'FileAddFilled'
  | 'FileAddOutlined'
  | 'FileAddTwoTone'
  | 'FileDoneOutlined'
  | 'FileExcelFilled'
  | 'FileExcelOutlined'
  | 'FileExcelTwoTone'
  | 'FileExclamationFilled'
  | 'FileExclamationOutlined'
  | 'FileExclamationTwoTone'
  | 'FileFilled'
  | 'FileGifOutlined'
  | 'FileImageFilled'
  | 'FileImageOutlined'
  | 'FileImageTwoTone'
  | 'FileJpgOutlined'
  | 'FileMarkdownFilled'
  | 'FileMarkdownOutlined'
  | 'FileMarkdownTwoTone'
  | 'FileOutlined'
  | 'FilePdfFilled'
  | 'FilePdfOutlined'
  | 'FilePdfTwoTone'
  | 'FilePptFilled'
  | 'FilePptOutlined'
  | 'FilePptTwoTone'
  | 'FileProtectOutlined'
  | 'FileSearchOutlined'
  | 'FileSyncOutlined'
  | 'FileTextFilled'
  | 'FileTextOutlined'
  | 'FileTextTwoTone'
  | 'FileTwoTone'
  | 'FileUnknownFilled'
  | 'FileUnknownOutlined'
  | 'FileUnknownTwoTone'
  | 'FileWordFilled'
  | 'FileWordOutlined'
  | 'FileWordTwoTone'
  | 'FileZipFilled'
  | 'FileZipOutlined'
  | 'FileZipTwoTone'
  | 'FilterFilled'
  | 'FilterOutlined'
  | 'FilterTwoTone'
  | 'FireFilled'
  | 'FireOutlined'
  | 'FireTwoTone'
  | 'FlagFilled'
  | 'FlagOutlined'
  | 'FlagTwoTone'
  | 'FolderAddFilled'
  | 'FolderAddOutlined'
  | 'FolderAddTwoTone'
  | 'FolderFilled'
  | 'FolderOpenFilled'
  | 'FolderOpenOutlined'
  | 'FolderOpenTwoTone'
  | 'FolderOutlined'
  | 'FolderTwoTone'
  | 'FolderViewOutlined'
  | 'FontColorsOutlined'
  | 'FontSizeOutlined'
  | 'ForkOutlined'
  | 'FormOutlined'
  | 'FormatPainterFilled'
  | 'FormatPainterOutlined'
  | 'ForwardFilled'
  | 'ForwardOutlined'
  | 'FrownFilled'
  | 'FrownOutlined'
  | 'FrownTwoTone'
  | 'FullscreenExitOutlined'
  | 'FullscreenOutlined'
  | 'FunctionOutlined'
  | 'FundFilled'
  | 'FundOutlined'
  | 'FundProjectionScreenOutlined'
  | 'FundTwoTone'
  | 'FundViewOutlined'
  | 'FunnelPlotFilled'
  | 'FunnelPlotOutlined'
  | 'FunnelPlotTwoTone'
  | 'GatewayOutlined'
  | 'GifOutlined'
  | 'GiftFilled'
  | 'GiftOutlined'
  | 'GiftTwoTone'
  | 'GithubFilled'
  | 'GithubOutlined'
  | 'GitlabFilled'
  | 'GitlabOutlined'
  | 'GlobalOutlined'
  | 'GoldFilled'
  | 'GoldOutlined'
  | 'GoldTwoTone'
  | 'GoldenFilled'
  | 'GoogleCircleFilled'
  | 'GoogleOutlined'
  | 'GooglePlusCircleFilled'
  | 'GooglePlusOutlined'
  | 'GooglePlusSquareFilled'
  | 'GoogleSquareFilled'
  | 'GroupOutlined'
  | 'HddFilled'
  | 'HddOutlined'
  | 'HddTwoTone'
  | 'HeartFilled'
  | 'HeartOutlined'
  | 'HeartTwoTone'
  | 'HeatMapOutlined'
  | 'HighlightFilled'
  | 'HighlightOutlined'
  | 'HighlightTwoTone'
  | 'HistoryOutlined'
  | 'HolderOutlined'
  | 'HomeFilled'
  | 'HomeOutlined'
  | 'HomeTwoTone'
  | 'HourglassFilled'
  | 'HourglassOutlined'
  | 'HourglassTwoTone'
  | 'Html5Filled'
  | 'Html5Outlined'
  | 'Html5TwoTone'
  | 'IdcardFilled'
  | 'IdcardOutlined'
  | 'IdcardTwoTone'
  | 'IeCircleFilled'
  | 'IeOutlined'
  | 'IeSquareFilled'
  | 'ImportOutlined'
  | 'InboxOutlined'
  | 'InfoCircleFilled'
  | 'InfoCircleOutlined'
  | 'InfoCircleTwoTone'
  | 'InfoOutlined'
  | 'InsertRowAboveOutlined'
  | 'InsertRowBelowOutlined'
  | 'InsertRowLeftOutlined'
  | 'InsertRowRightOutlined'
  | 'InstagramFilled'
  | 'InstagramOutlined'
  | 'InsuranceFilled'
  | 'InsuranceOutlined'
  | 'InsuranceTwoTone'
  | 'InteractionFilled'
  | 'InteractionOutlined'
  | 'InteractionTwoTone'
  | 'IssuesCloseOutlined'
  | 'ItalicOutlined'
  | 'KeyOutlined'
  | 'LaptopOutlined'
  | 'LayoutFilled'
  | 'LayoutOutlined'
  | 'LayoutTwoTone'
  | 'LeftCircleFilled'
  | 'LeftCircleOutlined'
  | 'LeftCircleTwoTone'
  | 'LeftOutlined'
  | 'LeftSquareFilled'
  | 'LeftSquareOutlined'
  | 'LeftSquareTwoTone'
  | 'LikeFilled'
  | 'LikeOutlined'
  | 'LikeTwoTone'
  | 'LineChartOutlined'
  | 'LineHeightOutlined'
  | 'LineOutlined'
  | 'LinkOutlined'
  | 'LinkedinFilled'
  | 'LinkedinOutlined'
  | 'Loading3QuartersOutlined'
  | 'LoadingOutlined'
  | 'LockFilled'
  | 'LockOutlined'
  | 'LockTwoTone'
  | 'LoginOutlined'
  | 'LogoutOutlined'
  | 'MacCommandFilled'
  | 'MacCommandOutlined'
  | 'MailFilled'
  | 'MailOutlined'
  | 'MailTwoTone'
  | 'ManOutlined'
  | 'MedicineBoxFilled'
  | 'MedicineBoxOutlined'
  | 'MedicineBoxTwoTone'
  | 'MediumCircleFilled'
  | 'MediumOutlined'
  | 'MediumSquareFilled'
  | 'MediumWorkmarkOutlined'
  | 'MehFilled'
  | 'MehOutlined'
  | 'MehTwoTone'
  | 'MenuFoldOutlined'
  | 'MenuOutlined'
  | 'MenuUnfoldOutlined'
  | 'MergeCellsOutlined'
  | 'MessageFilled'
  | 'MessageOutlined'
  | 'MessageTwoTone'
  | 'MinusCircleFilled'
  | 'MinusCircleOutlined'
  | 'MinusCircleTwoTone'
  | 'MinusOutlined'
  | 'MinusSquareFilled'
  | 'MinusSquareOutlined'
  | 'MinusSquareTwoTone'
  | 'MobileFilled'
  | 'MobileOutlined'
  | 'MobileTwoTone'
  | 'MoneyCollectFilled'
  | 'MoneyCollectOutlined'
  | 'MoneyCollectTwoTone'
  | 'MonitorOutlined'
  | 'MoreOutlined'
  | 'NodeCollapseOutlined'
  | 'NodeExpandOutlined'
  | 'NodeIndexOutlined'
  | 'NotificationFilled'
  | 'NotificationOutlined'
  | 'NotificationTwoTone'
  | 'NumberOutlined'
  | 'OneToOneOutlined'
  | 'OrderedListOutlined'
  | 'PaperClipOutlined'
  | 'PartitionOutlined'
  | 'PauseCircleFilled'
  | 'PauseCircleOutlined'
  | 'PauseCircleTwoTone'
  | 'PauseOutlined'
  | 'PayCircleFilled'
  | 'PayCircleOutlined'
  | 'PercentageOutlined'
  | 'PhoneFilled'
  | 'PhoneOutlined'
  | 'PhoneTwoTone'
  | 'PicCenterOutlined'
  | 'PicLeftOutlined'
  | 'PicRightOutlined'
  | 'PictureFilled'
  | 'PictureOutlined'
  | 'PictureTwoTone'
  | 'PieChartFilled'
  | 'PieChartOutlined'
  | 'PieChartTwoTone'
  | 'PlayCircleFilled'
  | 'PlayCircleOutlined'
  | 'PlayCircleTwoTone'
  | 'PlaySquareFilled'
  | 'PlaySquareOutlined'
  | 'PlaySquareTwoTone'
  | 'PlusCircleFilled'
  | 'PlusCircleOutlined'
  | 'PlusCircleTwoTone'
  | 'PlusOutlined'
  | 'PlusSquareFilled'
  | 'PlusSquareOutlined'
  | 'PlusSquareTwoTone'
  | 'PoundCircleFilled'
  | 'PoundCircleOutlined'
  | 'PoundCircleTwoTone'
  | 'PoundOutlined'
  | 'PoweroffOutlined'
  | 'PrinterFilled'
  | 'PrinterOutlined'
  | 'PrinterTwoTone'
  | 'ProfileFilled'
  | 'ProfileOutlined'
  | 'ProfileTwoTone'
  | 'ProjectFilled'
  | 'ProjectOutlined'
  | 'ProjectTwoTone'
  | 'PropertySafetyFilled'
  | 'PropertySafetyOutlined'
  | 'PropertySafetyTwoTone'
  | 'PullRequestOutlined'
  | 'PushpinFilled'
  | 'PushpinOutlined'
  | 'PushpinTwoTone'
  | 'QqCircleFilled'
  | 'QqOutlined'
  | 'QqSquareFilled'
  | 'QrcodeOutlined'
  | 'QuestionCircleFilled'
  | 'QuestionCircleOutlined'
  | 'QuestionCircleTwoTone'
  | 'QuestionOutlined'
  | 'RadarChartOutlined'
  | 'RadiusBottomleftOutlined'
  | 'RadiusBottomrightOutlined'
  | 'RadiusSettingOutlined'
  | 'RadiusUpleftOutlined'
  | 'RadiusUprightOutlined'
  | 'ReadFilled'
  | 'ReadOutlined'
  | 'ReconciliationFilled'
  | 'ReconciliationOutlined'
  | 'ReconciliationTwoTone'
  | 'RedEnvelopeFilled'
  | 'RedEnvelopeOutlined'
  | 'RedEnvelopeTwoTone'
  | 'RedditCircleFilled'
  | 'RedditOutlined'
  | 'RedditSquareFilled'
  | 'RedoOutlined'
  | 'ReloadOutlined'
  | 'RestFilled'
  | 'RestOutlined'
  | 'RestTwoTone'
  | 'RetweetOutlined'
  | 'RightCircleFilled'
  | 'RightCircleOutlined'
  | 'RightCircleTwoTone'
  | 'RightOutlined'
  | 'RightSquareFilled'
  | 'RightSquareOutlined'
  | 'RightSquareTwoTone'
  | 'RiseOutlined'
  | 'RobotFilled'
  | 'RobotOutlined'
  | 'RocketFilled'
  | 'RocketOutlined'
  | 'RocketTwoTone'
  | 'RollbackOutlined'
  | 'RotateLeftOutlined'
  | 'RotateRightOutlined'
  | 'SafetyCertificateFilled'
  | 'SafetyCertificateOutlined'
  | 'SafetyCertificateTwoTone'
  | 'SafetyOutlined'
  | 'SaveFilled'
  | 'SaveOutlined'
  | 'SaveTwoTone'
  | 'ScanOutlined'
  | 'ScheduleFilled'
  | 'ScheduleOutlined'
  | 'ScheduleTwoTone'
  | 'ScissorOutlined'
  | 'SearchOutlined'
  | 'SecurityScanFilled'
  | 'SecurityScanOutlined'
  | 'SecurityScanTwoTone'
  | 'SelectOutlined'
  | 'SendOutlined'
  | 'SettingFilled'
  | 'SettingOutlined'
  | 'SettingTwoTone'
  | 'ShakeOutlined'
  | 'ShareAltOutlined'
  | 'ShopFilled'
  | 'ShopOutlined'
  | 'ShopTwoTone'
  | 'ShoppingCartOutlined'
  | 'ShoppingFilled'
  | 'ShoppingOutlined'
  | 'ShoppingTwoTone'
  | 'ShrinkOutlined'
  | 'SignalFilled'
  | 'SisternodeOutlined'
  | 'SketchCircleFilled'
  | 'SketchOutlined'
  | 'SketchSquareFilled'
  | 'SkinFilled'
  | 'SkinOutlined'
  | 'SkinTwoTone'
  | 'SkypeFilled'
  | 'SkypeOutlined'
  | 'SlackCircleFilled'
  | 'SlackOutlined'
  | 'SlackSquareFilled'
  | 'SlackSquareOutlined'
  | 'SlidersFilled'
  | 'SlidersOutlined'
  | 'SlidersTwoTone'
  | 'SmallDashOutlined'
  | 'SmileFilled'
  | 'SmileOutlined'
  | 'SmileTwoTone'
  | 'SnippetsFilled'
  | 'SnippetsOutlined'
  | 'SnippetsTwoTone'
  | 'SolutionOutlined'
  | 'SortAscendingOutlined'
  | 'SortDescendingOutlined'
  | 'SoundFilled'
  | 'SoundOutlined'
  | 'SoundTwoTone'
  | 'SplitCellsOutlined'
  | 'StarFilled'
  | 'StarOutlined'
  | 'StarTwoTone'
  | 'StepBackwardFilled'
  | 'StepBackwardOutlined'
  | 'StepForwardFilled'
  | 'StepForwardOutlined'
  | 'StockOutlined'
  | 'StopFilled'
  | 'StopOutlined'
  | 'StopTwoTone'
  | 'StrikethroughOutlined'
  | 'SubnodeOutlined'
  | 'SwapLeftOutlined'
  | 'SwapOutlined'
  | 'SwapRightOutlined'
  | 'SwitcherFilled'
  | 'SwitcherOutlined'
  | 'SwitcherTwoTone'
  | 'SyncOutlined'
  | 'TableOutlined'
  | 'TabletFilled'
  | 'TabletOutlined'
  | 'TabletTwoTone'
  | 'TagFilled'
  | 'TagOutlined'
  | 'TagTwoTone'
  | 'TagsFilled'
  | 'TagsOutlined'
  | 'TagsTwoTone'
  | 'TaobaoCircleFilled'
  | 'TaobaoCircleOutlined'
  | 'TaobaoOutlined'
  | 'TaobaoSquareFilled'
  | 'TeamOutlined'
  | 'ThunderboltFilled'
  | 'ThunderboltOutlined'
  | 'ThunderboltTwoTone'
  | 'ToTopOutlined'
  | 'ToolFilled'
  | 'ToolOutlined'
  | 'ToolTwoTone'
  | 'TrademarkCircleFilled'
  | 'TrademarkCircleOutlined'
  | 'TrademarkCircleTwoTone'
  | 'TrademarkOutlined'
  | 'TransactionOutlined'
  | 'TranslationOutlined'
  | 'TrophyFilled'
  | 'TrophyOutlined'
  | 'TrophyTwoTone'
  | 'TwitterCircleFilled'
  | 'TwitterOutlined'
  | 'TwitterSquareFilled'
  | 'UnderlineOutlined'
  | 'UndoOutlined'
  | 'UngroupOutlined'
  | 'UnlockFilled'
  | 'UnlockOutlined'
  | 'UnlockTwoTone'
  | 'UnorderedListOutlined'
  | 'UpCircleFilled'
  | 'UpCircleOutlined'
  | 'UpCircleTwoTone'
  | 'UpOutlined'
  | 'UpSquareFilled'
  | 'UpSquareOutlined'
  | 'UpSquareTwoTone'
  | 'UploadOutlined'
  | 'UsbFilled'
  | 'UsbOutlined'
  | 'UsbTwoTone'
  | 'UserAddOutlined'
  | 'UserDeleteOutlined'
  | 'UserOutlined'
  | 'UserSwitchOutlined'
  | 'UsergroupAddOutlined'
  | 'UsergroupDeleteOutlined'
  | 'VerifiedOutlined'
  | 'VerticalAlignBottomOutlined'
  | 'VerticalAlignMiddleOutlined'
  | 'VerticalAlignTopOutlined'
  | 'VerticalLeftOutlined'
  | 'VerticalRightOutlined'
  | 'VideoCameraAddOutlined'
  | 'VideoCameraFilled'
  | 'VideoCameraOutlined'
  | 'VideoCameraTwoTone'
  | 'WalletFilled'
  | 'WalletOutlined'
  | 'WalletTwoTone'
  | 'WarningFilled'
  | 'WarningOutlined'
  | 'WarningTwoTone'
  | 'WechatFilled'
  | 'WechatOutlined'
  | 'WeiboCircleFilled'
  | 'WeiboCircleOutlined'
  | 'WeiboOutlined'
  | 'WeiboSquareFilled'
  | 'WeiboSquareOutlined'
  | 'WhatsAppOutlined'
  | 'WifiOutlined'
  | 'WindowsFilled'
  | 'WindowsOutlined'
  | 'WomanOutlined'
  | 'YahooFilled'
  | 'YahooOutlined'
  | 'YoutubeFilled'
  | 'YoutubeOutlined'
  | 'YuqueFilled'
  | 'YuqueOutlined'
  | 'ZhihuCircleFilled'
  | 'ZhihuOutlined'
  | 'ZhihuSquareFilled'
  | 'ZoomInOutlined'
  | 'ZoomOutOutlined'
